import { MenuItem, styled } from '@mui/material';
import type { MenuItemProps } from '@mui/material/MenuItem';

import { goPalette, tsGoUnit } from '../../tsGoThemeVars';

export const StyledMenuItem = styled(MenuItem)<MenuItemProps>(() => ({
	minHeight: tsGoUnit.tsUnitTriple,
	position: 'relative',
	color: goPalette.tsGoColor.grayLightest,

	'&:hover': {
		background: 'rgba(0, 0, 0, 0.04)',

		a: {
			background: 'rgba(0, 0, 0, 0.04)',
		},
	},
	a: {
		minHeight: tsGoUnit.tsUnitTriple,
		padding: 0,
		minWidth: 0,
		position: 'relative',
		overflow: 'hidden',
		'a span:first-of-type': {
			paddingTop: tsGoUnit.tsUnit,
		},
		'a span': {
			padding: '10px 0',
		},
	},
	'a:hover': {
		cursor: 'pointer',
		color: goPalette.tsGoColor.grayLightest,
		textDecoration: 'none',
	},
	'&.active-option': {
		backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'hsla(205, 20%, 18%, 1)' : 'rgba(25, 34, 38, 1)',
		overflow: 'hidden',

		'.expanded, .collapsed': {
			color: goPalette.tsGoColor.grayLightest,
		},

		':hover': {
			backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
				? 'hsla(205, 20%, 18%, 1)'
				: 'rgba(25, 34, 38, 1)',
		},
		'&:before': {
			backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
				? goPalette.hsbcColor.primary
				: goPalette.tsGoColor.pink,
			position: 'absolute',
			width: '3px',
			content: '""',
			top: 0,
			bottom: 0,
			boxShadow: `0 0 15px 1px ${goPalette.tsGoColor.pink}`,
		},
	},
}));
